<template>
  <div>
    <section class="acompanhamento-section content-padding">
      <div class="container">
        <h2 class="title">Acompanhamento da Votação por Regional</h2>
        <div class="subtitle mb-5">
          Acompanhe em tempo real o volume de participação dos eleitores em cada
          regional.
        </div>

        <div v-if="loading" class="text-center mt-5 mb-5">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
          <p class="mt-2">Carregando dados...</p>
        </div>

        <div v-else-if="error" class="alert alert-danger mt-4">
          Não foi possível carregar os dados no momento. Tente novamente mais
          tarde.
        </div>

        <div v-else class="row">
          <div
            class="col-md-6 col-lg-4 mb-4"
            v-for="regional in regionais"
            :key="regional.regionalId"
          >
            <v-card class="regional-card">
              <v-card-title class="regional-title primary white--text">
                {{ regional.nome }}
                <v-spacer></v-spacer>
                <span class="sigla">{{ regional.sigla }}</span>
              </v-card-title>
              <v-card-text class="pt-4">
                <div class="stat-row">
                  <span class="stat-label">Total de Eleitores:</span>
                  <span class="stat-value">{{ regional.totalEleitores }}</span>
                </div>
                <div class="stat-row">
                  <span class="stat-label">Total de Votantes:</span>
                  <span class="stat-value font-weight-bold primary--text">{{
                    regional.totalVotantes
                  }}</span>
                </div>

                <div class="mt-4">
                  <div class="d-flex justify-space-between mb-1">
                    <span class="text-caption">Participação</span>
                    <span class="text-caption font-weight-bold"
                      >{{ regional.percentual }}%</span
                    >
                  </div>
                  <v-progress-linear
                    :value="regional.percentual"
                    color="success"
                    height="10"
                    rounded
                  ></v-progress-linear>
                </div>
              </v-card-text>
            </v-card>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "AcompanhamentoRegional",
  data() {
    return {
      regionais: [],
      loading: true,
      error: false,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.error = false;
      try {
        const response = await axios.get(
          process.env.VUE_APP_API_URL + "/Eleitores/acompanhamento-regional"
        );
        this.regionais = response.data;
      } catch (e) {
        console.error("Erro ao buscar acompanhamento regional", e);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.content-padding {
  padding: 60px 0;
}
.title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 10px;
}
.subtitle {
  font-size: 1.1rem;
  color: #666;
}
.regional-card {
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  transition: transform 0.2s;
}
.regional-card:hover {
  transform: translateY(-5px);
}
.regional-title {
  font-size: 1.25rem;
  font-weight: 600;
  word-break: break-word;
}
.sigla {
  font-size: 0.9rem;
  opacity: 0.8;
}
.stat-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 1.1rem;
}
.stat-label {
  color: #555;
}
.stat-value {
  font-size: 1.2rem;
}
</style>
